import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from '@/store';
import { applyThemeVars } from '@/theme/cssVars';
import { ThemedRoot } from '@/components/ThemedRoot';
import { OneLatticeAuthProvider } from '@/auth/AuthProvider';
import App from './App';
import '@/theme/global.css';

// Paint the correct theme variables before first render (avoids a flash on long-shift screens).
applyThemeVars(store.getState().ui.theme);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ReduxProvider store={store}>
      <BrowserRouter>
        <ThemedRoot>
          <OneLatticeAuthProvider>
            <App />
          </OneLatticeAuthProvider>
        </ThemedRoot>
      </BrowserRouter>
    </ReduxProvider>
  </StrictMode>,
);
